import React, { Suspense } from "react";
import WelcomeBanner from "./WelcomeBanner";
import FeaturedProducts from "./FeaturedProducts";
import PreloadAssets from "./PreloadAssets";
import HomePageMeta from "./meta";
import SubscribeForm from "@/core/Forms/SubscribeForm";

// Lazy load components that are below the fold
const AboutSection = React.lazy(() => import("./AboutSection"));
const ImageGridGallery = React.lazy(() => import("./ImageGridGallery"));
const LocationSection = React.lazy(() => import("./LocationSection"));

// Loading component for better UX
const SectionLoader = () => (
  <div className="py-16 flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-cannabis-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const HomePage = () => {
  return (
    <div className="flex flex-col w-full">
      {/* Meta tags and asset preloading */}
      <HomePageMeta />
      <PreloadAssets />

      {/* Above the fold - Load immediately */}
      <WelcomeBanner />
      <FeaturedProducts />

      {/* Below the fold - Lazy load */}
      <Suspense fallback={<SectionLoader />}>
        <AboutSection />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <ImageGridGallery />
      </Suspense>

      <Suspense fallback={<SectionLoader />}>
        <LocationSection />
      </Suspense>

      {/* Newsletter Subscribe Section */}
      <SubscribeForm />
    </div>
  );
};

export default HomePage;
